module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/shield-thunder-77173d5f400386d45bf194d5a21f41c1.svg";